module.exports = __webpack_public_path__ + "fonts/extrablack.4454a52.woff";